export default function pluralize(count, verbs) {
  if (count == 1) {
    return `${count} ${verbs[0]}`;
  }
  return `${count} ${verbs[1]}`;
}
